module.exports = __webpack_public_path__ + "img/ledger.7ce0dfa5.jpg";